import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function displaySwitchOption(theme: Theme): ComponentStyle {
  return {
    componentName: 'displaySwitchOption',
    baseStyle: {
      padding: `${theme.space['2xs']}`,
      fontSize: theme.sizes['-1'],
      fontWeight: 600,
      color: theme.colors.spark.gray40,
      borderRadius: theme.sizes['-5'],
      transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',

      ['&:hover']: {
        backgroundColor: '#E9E9F3'
      }
    },
    states: {
      active: {
        backgroundColor: '#ffffff',
        boxShadow: '0 0 #000, 0 0 #000, 0px 1px 4px rgba(16, 16, 20, 0.05)',
        color: theme.colors.text
      }
    }
  };
}
